import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { useNavigate } from 'react-router';
import { Notification } from '@/assets/icons';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '../ui/button';
import { cn } from '@/lib/utils';
import { useState } from 'react';
import { useEffect } from 'react';
import { Skeleton } from '../ui/skeleton';
import { useGetActivities } from '@/services/data-services/Activities';
import { getActivityMessages } from '@/utils/activityMessages.jsx';

export function ActivityService() {
  let queryParams = `limit=5&page=1`;
  const { data, isLoading } = useGetActivities(queryParams);
  const [activities, setActivities] = useState([]);
  useEffect(() => {
    if (data?.activities?.length) {
      const sortedActivities = [...data.activities]
        .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
        .slice(0, 5);

      const messages = getActivityMessages(sortedActivities);
      setActivities(messages);
    }
  }, [data]);

  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen} ariaLabel="Open notifications">
      <PopoverTrigger onClick={() => setOpen(true)}>
        <Notification />
      </PopoverTrigger>
      <PopoverContent className="w-96 absolute top-0 -right-4 max-sm:-right-28">
        <div className="sticky flex items-center p-4 justify-between">
          <span className="">Notifications</span>
        </div>
        <div className="border-b border-input"></div>
        <div className="max-h-96 overflow-y-auto scrollbar-none">
          {isLoading ? (
            Array.from({ length: activities.length }).map((_, index) => (
              <div key={index} className="p-4 border-b border-input flex gap-5">
                <Skeleton className="h-8 w-20 bg-input rounded-full" />{' '}
                {/* Avatar Skeleton */}
                <div className="flex flex-col w-full">
                  <Skeleton className="h-4 w-3/4 mb-2 bg-input" />{' '}
                  {/* Message Skeleton */}
                  <Skeleton className="h-3 w-1/4 bg-input" />{' '}
                  {/* Date Skeleton */}
                </div>
              </div>
            ))
          ) : activities?.length > 0 ? (
            activities?.map((activity, index) => (
              <div key={index} className="border-b p-4 border-input">
                <div className="flex items-center gap-5">
                  <div>
                    <Avatar className="h-14 w-14">
                      <AvatarImage
                        src={`https://ui-avatars.com/api/?name=${encodeURIComponent(activity?.userName?.charAt(0))}&background=000000&color=fff&bold=true`}
                      />
                      <AvatarFallback>
                        {activity?.userName?.charAt(0)?.toUpperCase() || '!'}
                      </AvatarFallback>
                    </Avatar>
                  </div>
                  <div className="flex flex-col">
                    <span>{activity?.message}</span>
                    <span className="text-sm text-placeholder">
                      {activity?.formattedDate}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="p-4 text-center">No activities found.</div>
          )}
        </div>
        <div className="border-b border-input"></div>
        <div className="p-4">
          <Button
            variant="secondary"
            className={cn('w-full')}
            onClick={() => {
              setOpen(false);
              navigate('/activities');
            }}
          >
            View All
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
